// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const OPEN = 'OPEN';
export const CLOSE = 'CLOSE';
